import { ToastOptions, Zoom } from "react-toastify";

export const toastOptions: ToastOptions = {
    position: "bottom-right",
    transition: Zoom,
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
}